import React, { useState } from "react";
import { Box, Button, Typography, Alert, AlertTitle } from "@mui/material";
import AppModal from "ui/AppModal"; // Adjust the import path as needed
import GenerateSyncrCode from "./GenerateSyncCode"; // Adjust the import path

const SyncrChatAuthModal = ({ serverMessage, phone, onClose }) => {
  const [showAuthCode, setShowAuthCode] = useState(false);

  return (
    <AppModal
      heading="Syncr Authentication"
      onModalClose={onClose}
      customStyle={{ width: 550, borderRadius: "12px", p: 0 }}
    >
      <Box p={3}>
        <Alert severity="warning" sx={{ mb: 3 }}>
          <AlertTitle>Attention</AlertTitle>
          {serverMessage}
        </Alert>
        <Typography variant="body1" sx={{ mb: 2 }}>
          Would you like to receive an authentication code now?
        </Typography>
        {!showAuthCode ? (
          <Box display="flex" justifyContent="flex-end" mt={3}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => setShowAuthCode(true)}
              sx={{
                borderRadius: "4px",
                color: "white!important",
                border: "unset",
                marginLeft: "12px",
                height: "32px",
                minHeight: "unset",
              }}
            >
              Get Auth Code
            </Button>
            <Button
              onClick={onClose}
              variant="outlined"
              sx={{
                mr: 2,
                ml: 2,
                textTransform: "none",
                height: "32px",
                minHeight: "unset",
                color: "black!important",
              }}
            >
              Cancel
            </Button>
          </Box>
        ) : (
          <Box mt={3}>
            <GenerateSyncrCode phone={phone} showTable={false} />
          </Box>
        )}
      </Box>
    </AppModal>
  );
};

export default SyncrChatAuthModal;
